import { cva, type VariantProps } from 'class-variance-authority';

export const pillVariants = cva(
  'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full font-medium leading-none',
  {
    variants: {
      tone: {
        ok: 'bg-ok-soft text-ok-text',
        info: 'bg-info-soft text-info-text',
        warn: 'bg-accent-soft text-accent-text',
        off: 'bg-surface-3 text-muted',
        bad: 'bg-danger-soft text-danger-text',
      },
      size: {
        md: 'h-5.5 px-2 text-meta',
        lg: 'h-7 px-3 text-control',
      },
    },
    defaultVariants: { tone: 'off', size: 'md' },
  },
);

export type PillVariants = VariantProps<typeof pillVariants>;
export type PillTone = NonNullable<PillVariants['tone']>;
